// extracted by mini-css-extract-plugin
export default {"Container":"CustomerCheckout_Container__TNMLf","ReservationInfo":"CustomerCheckout_ReservationInfo__W9Bis","StationInfo":"CustomerCheckout_StationInfo__iOxpV"};